<template>
  <div class="content">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>返回</span>
    </div>
    <l-table
      ref="table"
      :tableConfig="tableConfig"
      :searchParams="searchParams"
      @tableChange="handleTableChange"
      emptyText="暂无数据"
      :emptyImgSrc="emptyImgSrc"
    >
      <template slot="searchConditions">
        <div class="search-box">
          <div class="search">
            <a-input v-model="searchParams.keyword" placeholder="请输入文件名称">
              <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
              <img
                class="clear"
                v-if="searchParams.keyword"
                slot="suffix"
                @click="searchParams.keyword = undefined"
                :src="require('@/assets/icons/icon_gb.png')"
              />
            </a-input>
            <div class="search_text"><span></span>搜索</div>
          </div>
        </div>
      </template>
      <template #searchActions>
        <a-button v-if="userType !== 'student'" type="primary" @click="create">上传文件</a-button>
      </template>
      <template #status="{ record }">
        <a-switch :checked="record.status === '1'" @change="changeStatus(record)" />
      </template>
      <template #operates="{ record }">
        <div class="operates">
          <a-tooltip placement="top">
            <template slot="title">
              <span>查看</span>
            </template>
            <a-icon type="eye" theme="filled" class="operate-icon" @click="viewDetails(record)" />
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>编辑</span>
            </template>
            <a-icon type="edit" theme="filled" class="operate-icon" @click="edit(record)" />
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>删除</span>
            </template>
            <a-icon type="delete" theme="filled" class="operate-icon" @click="delModal(record.id)" />
          </a-tooltip>
        </div>
      </template>
      <template #create>
        <a-button type="primary" @click="create">上传文件</a-button>
      </template>
      <template #serchTip>
        <p>请换一个搜索词吧~</p>
      </template>
    </l-table>
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
        <p>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.title}</p>
        <p class='placeholder'>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.content}</p>`
      "
    />
    <!-- 添加编辑文件名称的弹窗 -->
    <a-modal
      title="编辑文件名称"
      :visible="editNameVisible"
      @ok="saveFileName"
      @cancel="editNameVisible = false"
      okText="确定"
      cancelText="取消"
    >
      <a-input v-model="editFileName" maxLength="30" placeholder="请输入文件名称" />
    </a-modal>
    <!-- 处理进度框 -->
    <TipModal
      :okText="'我已知晓'"
      :className="['nocancel']"
      :visible="noControlVisible"
      @ok="noControlVisible = false"
      :desc="`<p><p style='margin-top:10px'>数据处理中（${process}%）</p></p>`"
    />
  </div>
</template>

<script>
import jsCookie from 'js-cookie'
import LTable from '@/components/LTable/index.vue'
import TipModal from '@/components/tipModal/index.vue'
import { ticket, portalExperimentDetail } from '@/api/experiment'
import Upload from '@/components/upload/index.vue'
import { setDocumentStatus, deleteDocument, renameDocument } from '@/api/ai.js'
import { getDocumentEmbedProgress } from '@/api/aiApp.js'
import { dataSet } from '@/data/app.js'
const dataSetId = dataSet.id

const userType = JSON.parse(jsCookie.get('user_type')).join(',')
const data = []
export default {
  components: {
    LTable,
    TipModal,
    Upload
  },
  data() {
    return {
      searchParams: {
        datasetId: undefined,
        keyword: undefined,
        startTime: undefined,
        endTime: undefined
      },
      tableConfig: {
        tableName: '',
        tableColumns: [
          {
            title: '文件名称',
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: '编辑时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
            align: 'center',
            width: 180,
            sorter: () => { }
          },
          {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 100,
            customSlots: true,
            scopedSlots: { customRender: 'status' },
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: '开启', value: '1' },
              { text: '关闭', value: '2' }
            ]
          },
          {
            title: '操作',
            width: 180,
            dataIndex: 'operates',
            key: 'operates',
            align: 'center',
            customSlots: true,
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tableDeleteTip: {
          title: '确定要删除该知识库文档？',
          content: '文档删除后无法找回'
        },
        tablePort: {
          list: '/ai/document/list',
          del: '/ai/document/delete'
        },
        tableData: data
      },
      delVisible: false,
      delId: '',
      userType,
      emptyImgSrc: require('@/assets/img/pic_zhishiku@2x.png'),
      uploadVisible: false,
      uploading: false,
      fileList: [],
      currentRecord: null,
      dateRange: null,
      editNameVisible: false,
      process: 0,
      noControlVisible: false
    }
  },
  watch: {
    dateRange(val) {
      if (val.length === 2) {
        this.searchParams.startTime = val[0].startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.endTime = val[1].endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      }
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'repository'
      })
    },
    onChange() {
      this.searchParams.startTime = this.dateRange[0]
        ? this.dateRange[0].startOf('day').format('YYYY-MM-DD HH:mm:ss')
        : ''
      this.searchParams.endTime = this.dateRange[1] ? this.dateRange[1].endOf('day').format('YYYY-MM-DD HH:mm:ss') : ''
    },
    create() {
      this.$router.push({
        name: 'createFlow',
        query: {
          id: this.searchParams.datasetId
        }
      })
    },
    del() {
      deleteDocument({ id: this.delId }).then(res => {
        if (res.code === 200) {
          this.delVisible = false
          this.$message.success('删除成功！')
          this.$refs.table.getList()
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    showUploadModal(record) {
      this.currentRecord = record
      const currentTime = new Date()
      this.pathname =
        'school-level-platform/' +
        currentTime.getFullYear() +
        (currentTime.getMonth() + 1) +
        currentTime.getDate() +
        '/' +
        new Date().getTime().toString() +
        '.pdf'
      this.uploadVisible = true
      this.fileList = []
    },
    viewDetails(obj) {
      getDocumentEmbedProgress(
        { datasetId: dataSetId, batch: obj.batch },
        {
          'X-App-Id': 'dataset'
        }
      ).then(res => {
        if (res && res.data && res.data.length > 0 && res.data[0].indexing_status === 'completed') {
          this.$router.push({
            name: 'repositoryDetails',
            query: { id: obj.difyDocumentId, datasetId: this.searchParams.datasetId, documentId: obj.id }
          })
        } else if (res && res.data && res.data.length > 0 && res.data[0].indexing_status === 'indexing') {
          this.noControlVisible = true
          this.process = ((res.data[0].completed_segments / res.data[0].total_segments) * 100).toFixed(2)
        } else {
          this.$message.error('该文档暂无分段数据')
        }
      })
    },
    toExamine() {
      // this.$router.push({ name: 'experimentCheckExamine' })
    },
    handleTableChange([filters, getList, sort]) {
      console.log('filters ----->', filters)
      const result = {}
      for (const key in filters) {
        if (filters[key]) {
          result[key] = filters[key].length > 1 ? '' : filters[key][0]
        }
      }
      getList({ condition: { ...result, sortRule: sort.order === 'ascend' ? 'asc' : 'desc' } })
    },
    async goCheck(id, examineId) {
      const ticketRes = await ticket()
      const detaisRes = await portalExperimentDetail({ id: examineId })
      window.open(`${detaisRes.data.url}?ticket=${ticketRes.data.ticket}&examine_id=${id}`)
      // { ticket: ticketRes.data, examine_id: id }
      console.log('detaisRes ----->', `${detaisRes.data.url}?ticket=${ticketRes.data.ticket}&examine_id=${id}`)
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    changeStatus(record) {
      setDocumentStatus({
        documentId: record.id,
        status: record.status === '1' ? '2' : '1'
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('状态已更新')
          this.$refs.table.getList()
        }
      })
    },
    // 打开编辑文件名称弹窗
    edit(record) {
      this.editNameVisible = true
      this.editFileName = record.name
      this.editFileId = record.id
    },

    // 保存文件名称
    saveFileName() {
      if (!this.editFileName.trim()) {
        this.$message.error('文件名称不能为空')
        return
      }

      renameDocument({
        documentId: this.editFileId,
        name: this.editFileName.trim()
      })
        .then(res => {
          if (res.code === 200) {
            this.$message.success('文件名称修改成功')
            this.editNameVisible = false
            this.$refs.table.getList() // 刷新表格数据
          }
        })
        .catch(err => {
          this.$message.error('修改失败：' + (err.message || '未知错误'))
        })
    }
  },
  created() {
    this.searchParams.datasetId = this.$route.query.id
  }
}
</script>

<style lang="less" scoped>
/deep/ .operates {
  display: flex;
  align-items: center;
  justify-content: center;
  .more {
    position: relative;
    width: 20px;
    height: 20px;
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      transition: all 0.3s;
    }
    img:nth-child(1) {
      opacity: 0;
    }
    img:nth-child(2) {
      opacity: 1;
    }
  }
  &:hover {
    img:nth-child(1) {
      opacity: 1;
    }
    img:nth-child(2) {
      opacity: 0;
    }
  }
}
.content {
  padding: 19px 19px;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .container {
    padding-top: 0;
    height: auto;
  }
  .search-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .search {
    width: 330px;
    position: relative;
    margin-right: 20px;
    .search_text {
      position: absolute;
      top: 6px;
      right: 20px;
      display: flex;
      z-index: 5;
      cursor: pointer;
      span {
        display: inline-block;
        width: 1px;
        height: 10px;
        background: #e9e9e9;
        margin-right: 8px;
        margin-top: 6px;
      }
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
    /deep/ .ant-input-affix-wrapper {
      width: 330px;
    }
    /deep/ .ant-input {
      width: 330px;
      height: 35px;
      color: #000;
      margin-right: 30px;
      border-radius: 20px;
      padding-right: 59px;
    }
    /deep/ .ant-input-suffix {
      right: 62px;
    }
  }
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover span {
  color: #384959;
}
.operate-icon {
  color: #6b738c;
  margin-right: 20px;
  font-size: 18px;
  cursor: pointer;
  &:hover {
    color: #ff6d00;
  }
  &:last-child {
    margin-right: 0;
  }
}
</style>
<style lang="less">
.l-dropdown-menu-btn {
  .action {
    border-radius: 20px;
    text-align: center;
    padding: 7px 10px;
    background-color: #f8f8f8;
  }
  .ant-dropdown-menu-item {
    width: 86px;
    height: 30px;
    display: flex;
    font-size: 12px;
    margin: 7px 8px;
    font-weight: 400;
    line-height: 17px;
    align-items: center;
    border-radius: 15px;
    background: #f8f8f8;
    //  !important;
    img {
      width: 12px !important;
      height: 12px;
      margin-right: 6px;
    }
    span {
      width: 100%;
      color: #384959;
      display: inline-block;
      text-align-last: justify;
    }
    &:hover span {
      color: #ff6d00;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/ .operates {
  display: flex;
  align-items: center;
  justify-content: center;
  .more {
    position: relative;
    width: 20px;
    height: 20px;
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      transition: all 0.3s;
    }
    img:nth-child(1) {
      opacity: 0;
    }
    img:nth-child(2) {
      opacity: 1;
    }
  }
  &:hover {
    img:nth-child(1) {
      opacity: 1;
    }
    img:nth-child(2) {
      opacity: 0;
    }
  }
}
.content {
  padding: 19px 19px;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .container {
    padding-top: 0;
  }
  .search-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .search {
    width: 330px;
    position: relative;
    margin-right: 20px;
    .search_text {
      position: absolute;
      top: 6px;
      right: 20px;
      display: flex;
      z-index: 5;
      cursor: pointer;
      span {
        display: inline-block;
        width: 1px;
        height: 10px;
        background: #e9e9e9;
        margin-right: 8px;
        margin-top: 6px;
      }
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
    /deep/ .ant-input-affix-wrapper {
      width: 330px;
    }
    /deep/ .ant-input {
      width: 330px;
      height: 35px;
      color: #000;
      margin-right: 30px;
      border-radius: 20px;
      padding-right: 59px;
    }
    /deep/ .ant-input-suffix {
      right: 62px;
    }
  }
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover span {
  color: #384959;
}
.operate-icon {
  color: #6b738c;
  margin-right: 20px;
  font-size: 18px;
  cursor: pointer;
  &:hover {
    color: #ff6d00;
  }
  &:last-child {
    margin-right: 0;
  }
}
</style>
<style lang="less">
.l-dropdown-menu-btn {
  .action {
    border-radius: 20px;
    text-align: center;
    padding: 7px 10px;
    background-color: #f8f8f8;
  }
  .ant-dropdown-menu-item {
    width: 86px;
    height: 30px;
    display: flex;
    font-size: 12px;
    margin: 7px 8px;
    font-weight: 400;
    line-height: 17px;
    align-items: center;
    border-radius: 15px;
    background: #f8f8f8;
    //  !important;
    img {
      width: 12px !important;
      height: 12px;
      margin-right: 6px;
    }
    span {
      width: 100%;
      color: #384959;
      display: inline-block;
      text-align-last: justify;
    }
    &:hover span {
      color: #ff6d00;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/ .operates {
  display: flex;
  align-items: center;
  justify-content: center;
  .more {
    position: relative;
    width: 20px;
    height: 20px;
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      transition: all 0.3s;
    }
    img:nth-child(1) {
      opacity: 0;
    }
    img:nth-child(2) {
      opacity: 1;
    }
  }
  &:hover {
    img:nth-child(1) {
      opacity: 1;
    }
    img:nth-child(2) {
      opacity: 0;
    }
  }
}
.content {
  padding: 19px 19px;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .container {
    padding-top: 0;
  }
  .search-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .search {
    width: 330px;
    position: relative;
    margin-right: 20px;
    .search_text {
      position: absolute;
      top: 6px;
      right: 20px;
      display: flex;
      z-index: 5;
      cursor: pointer;
      span {
        display: inline-block;
        width: 1px;
        height: 10px;
        background: #e9e9e9;
        margin-right: 8px;
        margin-top: 6px;
      }
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
    /deep/ .ant-input-affix-wrapper {
      width: 330px;
    }
    /deep/ .ant-input {
      width: 330px;
      height: 35px;
      color: #000;
      margin-right: 30px;
      border-radius: 20px;
      padding-right: 59px;
    }
    /deep/ .ant-input-suffix {
      right: 62px;
    }
  }
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover span {
  color: #384959;
}
.operate-icon {
  color: #6b738c;
  margin-right: 20px;
  font-size: 18px;
  cursor: pointer;
  &:hover {
    color: #ff6d00;
  }
  &:last-child {
    margin-right: 0;
  }
}
</style>
<style lang="less">
.l-dropdown-menu-btn {
  .action {
    border-radius: 20px;
    text-align: center;
    padding: 7px 10px;
    background-color: #f8f8f8;
  }
  .ant-dropdown-menu-item {
    width: 86px;
    height: 30px;
    display: flex;
    font-size: 12px;
    margin: 7px 8px;
    font-weight: 400;
    line-height: 17px;
    align-items: center;
    border-radius: 15px;
    background: #f8f8f8;
    //  !important;
    img {
      width: 12px !important;
      height: 12px;
      margin-right: 6px;
    }
    span {
      width: 100%;
      color: #384959;
      display: inline-block;
      text-align-last: justify;
    }
    &:hover span {
      color: #ff6d00;
    }
  }
}
</style>
